import { Component, OnInit } from '@angular/core';
import { ValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../api.service';
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-bulk-import',
  templateUrl: './bulk-import.component.html',
  styleUrls: ['./bulk-import.component.css'],
  providers: [NgxSpinnerService]
})
export class BulkImportComponent implements OnInit {

  private passwordMatchValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    return password.value === confirmPassword.value ? null : { 'passwordsDontMatch': true };
  }

  formSubmitted: boolean = false;
  profilePicture: File;
  picturePreview: any;

  lang: any = localStorage.getItem("language")?localStorage.getItem("language"):'en';
  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    public functionsService: FunctionsService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService) { }

    data:any;

  ngOnInit() {
      this.spinner.hide();
  }

  saveBulkImport(){
    this.spinner.show();
    document.getElementById("bulk_upload").hidden = true;
    document.getElementById("buttons_bulk").hidden =true; 
    
    this.apiService.userBulkImport(this.data.toString()).subscribe(
        data => {
           document.getElementById("bulk_instructions").hidden = true;
           document.getElementById("ok_button").hidden = false;
           this.spinner.hide();
           data = data.toString().split("invalid_data").join(this.translate.instant("invalid_data"));
           data = data.toString().split("string_length_20").join(this.translate.instant("string_length_20"));
           data = data.toString().split("fname_string_length_50").join(this.translate.instant("fname_string_length_50"));
           data = data.toString().split("lname_string_length_50").join(this.translate.instant("lname_string_length_50"));
           data = data.toString().split("string_length_320").join(this.translate.instant("string_length_320"));
           data = data.toString().split("email_required").join(this.translate.instant("email_required"));
           data = data.toString().split("first_name_required").join(this.translate.instant("first_name_required"));
           data = data.toString().split("last_name_required").join(this.translate.instant("last_name_required"));
           data = data.toString().split("phone_required").join(this.translate.instant("phone_required"));
           data = data.toString().split("email_validation_error").join(this.translate.instant("email_validation_error"));
           data = data.toString().split("fname_validation_error").join(this.translate.instant("fname_validation_error"));
           data = data.toString().split("lname_validation_error").join(this.translate.instant("lname_validation_error"));
           data = data.toString().split("phone_validation_error").join(this.translate.instant("phone_validation_error"));
           data = data.toString().split("error_account_row").join(this.translate.instant("error_account_row"));
           data = data.toString().split("not_created").join(this.translate.instant("not_created"));
           data = data.toString().split("phone_exists_bulk").join(this.translate.instant("phone_exists_bulk"));
           data = data.toString().split("user_exists_bulk").join(this.translate.instant("user_exists_bulk"));
           data = data.toString().split("user_exceeds_bulk").join(this.translate.instant("user_exceeds_bulk"));
           data = data.toString().split("row").join(this.translate.instant("row"));
           data = data.toString().split("following_errors").join(this.translate.instant("following_errors"));
           data = data.toString().split("total_of").join(this.translate.instant("total_of"));
           data = data.toString().split("account_created").join(this.translate.instant("account_created"));
           data = data.toString().split("accounts_created").join(this.translate.instant("accounts_created"));
           data = data.toString().split("partially_created").join(this.translate.instant("partially_created"));
           document.getElementById("output_message").innerHTML = data.toString();
        }, error => {
           document.getElementById("bulk_instructions").hidden = true; 
           document.getElementById("ok_button").hidden = false;
           document.getElementById("output_message").innerHTML = this.translate.instant('bulk_import.file_error');
                this.translate.onLangChange.subscribe(() => {
                    document.getElementById("output_message").innerHTML = this.translate.instant('bulk_import.file_error');
                });
           if(error["error"]["content"]!=null){
              document.getElementById("error_message").innerHTML = this.translate.instant(error["error"]["content"]);
              this.translate.onLangChange.subscribe(() => {
                if(error["error"]["content"]!=null){
                  document.getElementById("error_message").innerHTML = this.translate.instant(error["error"]["content"]);
                }
            });
           }
           this.spinner.hide();
        }
    );
  }

  resetFile(e){
    const element = e.target as HTMLInputElement
    element.value = ''
  }
  
  handleBulkImportUpload(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    document.getElementById("type-error").innerHTML = "";
    document.getElementById("fileLabel").innerHTML = evt.target.files[0].name;
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    //Validate file type
    var validTypes = ["application/vnd.ms-excel","text/csv","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
    if(!validTypes.includes(target.files[0].type)){
        document.getElementById("type-error").innerHTML = this.translate.instant('bulk_import.invalid_format');
        (<HTMLInputElement>document.getElementById("add_bulk")).disabled =true; 
        return false;
    }
    
    const reader: FileReader = new FileReader();
    var rowNum = 0;
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
      /* grab first sheet */
      let jsonData = wb.SheetNames.reduce((initial, name) => {
        const sheet = wb.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        var range = XLSX.utils.decode_range(sheet['!ref']);
        rowNum = range.e.r;
        return initial;
      }, {});
      
      this.data = JSON.stringify(jsonData);
      if(rowNum > 100){
        reader.removeEventListener;
        document.getElementById("type-error").innerHTML = this.translate.instant('bulk_import.max_rows');
        return false;
      }
      
      (<HTMLInputElement>document.getElementById("add_bulk")).disabled = false; 
    };
    reader.readAsBinaryString(target.files[0]);
  }

  saveAsExcelFile(bType: string): void {  
    const fileName = "sample_template_SA."+bType;

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([{"FirstName":"","LastName":"","PhoneNumber":"","Email":""}]);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'sample_template_SA');

    XLSX.writeFile(wb, fileName);
  }  
}
